import { createReducer } from '@reduxjs/toolkit';
import { expiredAction } from '../actions/expiredAction';

const initialState = {
  isExpired: false,
};
export default createReducer(initialState, (builder) => {
  builder.addCase(expiredAction, (state, action) => ({
    ...state,
    isExpired: action.payload,
  }));
});
